import { Injectable } from '@angular/core';
import { Dialog } from '@core/models/dialog.interface';

// Modal
import { NzModalService } from 'ng-zorro-antd/modal';


@Injectable({
  providedIn: 'root'
})
export class ModalService {

  modal:any
  
  constructor(private nzModalService:NzModalService) { }

  public openModal(template:any | string, nzCol:string, bodyStyle:any | object, param:Dialog, isCloseIcon:boolean = true) {
    const modal = this.nzModalService.create({
      nzTitle: "",
      nzContent: template,
      nzClassName: 'dialog-class ' + nzCol,
      nzComponentParams: {params: param},
      nzFooter: null,
      nzMaskClosable: false,
      nzCentered: true,
      nzClosable: isCloseIcon,      
      nzWidth: '',
      nzBodyStyle: bodyStyle,
    });

    return modal;
  }

  closeAllModals() {
    if(this.modal) {
      this.modal.close()
    }
  }

}
